/**
 * Normalizes a single value, array, or nullish input into an array - `null`/`undefined` become
 * `[]`, a bare value becomes a one-item array, and an array passes through unchanged.
 */
export const toIdArray = (value: string | string[] | null | undefined): string[] =>
  Array.isArray(value) ? value : value ? [value] : [];

/**
 * Drops null/undefined/empty-string entries from a list of possibly-missing ids - e.g. building
 * an `excludeIds` list from several independently-optional id sources (a target employee, a
 * sibling field's current selection, etc.).
 */
export const compactIds = (ids: Array<string | null | undefined>): string[] =>
  ids.filter((id): id is string => Boolean(id));
